/** Overlays stack from here upwards, clear of the fixed app chrome below 10000. */
export const OVERLAY_LAYER_BASE = 10000;

/** For chrome that must stay visible however deep the overlay stack gets. */
export const OVERLAY_LAYER_TOP = 20000;
